import React from 'react';
import {
    Bar,
    Title,
    BackIcon,
    RightIcon,
} from './Topbar.style';

const Topbar = ({
    title,
    rightIcon = '',
    shadow = true,
    showLeftIcon = true,
    align = 'center',
    goBack,
    isBlack
}) => {

    return (
        <Bar isBlack={isBlack} id='top-bar' shadow={shadow ? 'hide' : 'hide'}>
            {showLeftIcon && <BackIcon onClick={() => goBack()} />}
            <Title align={align}>
                {title}
            </Title>
            {rightIcon &&
                <RightIcon>
                    {rightIcon}
                </RightIcon>
            }
        </Bar>
    );
}

export default Topbar;